import { type Client, graphql, prefetch } from "@opensea/graphql"
import { CollectionNavigationFragment } from "@/components/collection/CollectioNavigation.fragment"
import {
  CollectionDropProviderCollectionFragment,
  CollectionDropProviderDropFragment,
} from "@/components/collection/drops/components/CollectionDropContext"
import { CollectionHeaderFragment } from "@/components/collection/header/CollectionHeader"
import { CollectionOverviewFragment } from "@/components/collection/overview/CollectionOverview.fragment"
import { CollectionHeaderPreviewFragment } from "@/components/collection/overview/components/CollectionOverviewPreview/components/CollectionHeaderPreview"
import { CollectionJsonLdFragment } from "@/components/seo/CollectionJsonLD"
import { useCollectionTitleFragment } from "@/hooks/use-collection-title"

export const COLLECTION_PAGE_LAYOUT_QUERY = graphql(
  `
    query CollectionPageLayoutQuery($collectionSlug: String!) {
      collectionBySlug(slug: $collectionSlug) {
        __typename
        ... on Collection {
          slug
          floorPrice {
            pricePerItem {
              token {
                unit
                symbol
              }
            }
          }
          flags {
            isOffersEnabled
            isRarityDisabled
          }
          ...CollectionNavigation
          ...CollectionJsonLd
        }
        ... on DelistedCollection {
          slug
        }
        ... on BlacklistedCollection {
          slug
        }
        ...CollectionDropProvider_collection
        ...CollectionHeader
        ...CollectionHeaderPreview
        ...CollectionOverview
        ...useCollectionTitle
      }
      dropBySlug(slug: $collectionSlug) {
        ...CollectionDropProvider_drop
      }
    }
  `,
  [
    CollectionHeaderFragment,
    CollectionHeaderPreviewFragment,
    CollectionOverviewFragment,
    useCollectionTitleFragment,
    CollectionDropProviderCollectionFragment,
    CollectionDropProviderDropFragment,
    CollectionNavigationFragment,
    CollectionJsonLdFragment,
  ],
)

export const prefetchCollectionPageLayout = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, COLLECTION_PAGE_LAYOUT_QUERY, { collectionSlug })
}
